(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller"] && !Shopify.designMode) return;
  try {
    
// $(document).ready(function () {
//     $(".cus-btn").on("click", function (event) {
//         event.preventDefault();

//         let productId = $(this).data("product-id");

//         $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: { quantity: 1, id: productId },
//             dataType: "json",
//             success: function () {
//               $(".drawer:first").addClass("active");
//                         setTimeout(()=>{
//              $('#drawtop').load(location.href + ' #CartDrawer');
//           },1000)
//             },
//             error: function (error) {
//                 console.error("Error adding to cart:", error);
//             }
//         });
//     });
// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
const slider = document.querySelector('.hero-slider');
const slides = slider.querySelectorAll('.hero-slide');
const prev = slider.querySelector('.prev');
const next = slider.querySelector('.next');

let index = 0;
let interval;

function showSlide(i) {
  slides.forEach(s => s.classList.remove('active'));
  slides[i].classList.add('active');
}

function nextSlide() {
  index = (index + 1) % slides.length;
  showSlide(index);
}

function prevSlide() {
  index = (index - 1 + slides.length) % slides.length;
  showSlide(index);
}

// Adjust autoplay speed based on device
function getAutoplaySpeed() {
  if (window.innerWidth <= 575) return 5000; // Slower on mobile
  if (window.innerWidth <= 1023) return 4500; // Medium on tablet
  return 4000; // Default on desktop
}

if (slider.dataset.autoplay === 'true') {
  interval = setInterval(nextSlide, getAutoplaySpeed());
}

// Handle autoplay reset on window resize
function resetAutoplay() {
  clearInterval(interval);
  if (slider.dataset.autoplay === 'true') {
    interval = setInterval(nextSlide, getAutoplaySpeed());
  }
}

next.addEventListener('click', () => {
  clearInterval(interval);
  nextSlide();
  // Restart autoplay after manual interaction if enabled
  if (slider.dataset.autoplay === 'true') {
    setTimeout(() => {
      interval = setInterval(nextSlide, getAutoplaySpeed());
    }, 5000);
  }
});

prev.addEventListener('click', () => {
  clearInterval(interval);
  prevSlide();
  // Restart autoplay after manual interaction if enabled
  if (slider.dataset.autoplay === 'true') {
    setTimeout(() => {
      interval = setInterval(nextSlide, getAutoplaySpeed());
    }, 5000);
  }
});

// Add touch swipe support for mobile
let touchStartX = 0;
let touchEndX = 0;

slider.addEventListener('touchstart', e => {
  touchStartX = e.changedTouches[0].screenX;
});

slider.addEventListener('touchend', e => {
  touchEndX = e.changedTouches[0].screenX;
  handleSwipe();
});

function handleSwipe() {
  const swipeThreshold = 50;
  
  if (touchEndX < touchStartX - swipeThreshold) {
    // Swipe left = next
    clearInterval(interval);
    nextSlide();
  }
  
  if (touchEndX > touchStartX + swipeThreshold) {
    // Swipe right = previous
    clearInterval(interval);
    prevSlide();
  }
  
  // Restart autoplay after swipe
  if (slider.dataset.autoplay === 'true') {
    setTimeout(() => {
      interval = setInterval(nextSlide, getAutoplaySpeed());
    }, 5000);
  }
}

// Handle window resize
window.addEventListener('resize', resetAutoplay);

  } catch(e) { console.error(e); }
})();
})();
